/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type StoreHistoryManagementEditOrderUnitRequest = {
    id?: number;
    deliveryType: StoreHistoryManagementEditOrderUnitRequest.deliveryType;
    deliveryPreferredDate?: string | null;
    deliveryPreferredTime?: StoreHistoryManagementEditOrderUnitRequest.deliveryPreferredTime | null;
    shippingNumber?: string | null;
    postage: number;
    isDeleted: boolean;
};

export namespace StoreHistoryManagementEditOrderUnitRequest {

    export enum deliveryType {
        YAMATO = 'yamato',
        SAGAWA = 'sagawa',
    }

    export enum deliveryPreferredTime {
        '_1' = 1,
        '_2' = 2,
        '_3' = 3,
        '_4' = 4,
        '_5' = 5,
        '_6' = 6,
    }


}

